var bluemoon;
(function (bluemoon) {
    var accounting;
    (function (accounting) {
        var Components;
        (function (Components) {
            'use strict';
            var QuarterReportStatementsArController = (function () {
                function QuarterReportStatementsArController(authenticatedSessionData, quarterReportStatementUrlManager, $window) {
                    var _this = this;
                    this.authenticatedSessionData = authenticatedSessionData;
                    this.quarterReportStatementUrlManager = quarterReportStatementUrlManager;
                    this.$window = $window;
                    this.currentYear = new Date().getFullYear();
                    this.currentDate = new Date();
                    this.selectedYear = this.currentYear;
                    this.isLoading = false;
                    this.secondQuarterStartDate = new Date(this.currentYear, 4, 1);
                    this.thirdQuarterStartDate = new Date(this.currentYear, 8, 1);
                    this.currentYear = new Date().getFullYear();
                    this.selectedYear = this.currentYear;
                    authenticatedSessionData.get().then(function (sessionData) {
                        _this.loadedCompanyId = sessionData.bindings.ApplicationConfiguration.CompanyId;
                    });
                }
                QuarterReportStatementsArController.prototype.reduceYear = function () {
                    this.selectedYear--;
                };
                QuarterReportStatementsArController.prototype.increaseYear = function () {
                    if (this.selectedYear < this.currentYear) {
                        this.selectedYear++;
                    }
                };
                QuarterReportStatementsArController.prototype.openReport = function (quarter) {
                    var _this = this;
                    this.isLoading = true;
                    this.quarterReportStatementUrlManager.getReportUrl(this.loadedCompanyId, this.currentClient.id, this.selectedYear, quarter)
                        .then(function (response) {
                        _this.$window.open(response, '_blank');
                    }).finally(function () {
                        _this.isLoading = false;
                    });
                };
                QuarterReportStatementsArController.prototype.showQuarter = function (quarter) {
                    if (quarter === 2) {
                        return this.selectedYear < this.currentYear ||
                            this.currentDate >= this.secondQuarterStartDate;
                    }
                    if (quarter === 3) {
                        return this.selectedYear < this.currentYear ||
                            this.currentDate >= this.thirdQuarterStartDate;
                    }
                };
                QuarterReportStatementsArController.$inject = ['AuthenticatedSessionData', 'quarterReportStatementUrlManager', '$window'];
                return QuarterReportStatementsArController;
            }());
            Components.QuarterReportStatementsArController = QuarterReportStatementsArController;
            var QuarterReportStatementsAr = (function () {
                function QuarterReportStatementsAr() {
                    this.bindings = {
                        currentClient: '<'
                    };
                    this.controller = QuarterReportStatementsArController;
                    this.templateUrl = 'src/dashboards/quarter-report-statements-ar/quarter-report-statements-ar.html';
                }
                return QuarterReportStatementsAr;
            }());
            Components.QuarterReportStatementsAr = QuarterReportStatementsAr;
            angular.module('bluemoon.accounting.components.QuarterReportStatementsAr', [])
                .component('quarterReportStatementsAr', new QuarterReportStatementsAr())
                .controller('quarterReportStatementsArController', QuarterReportStatementsArController);
        })(Components = accounting.Components || (accounting.Components = {}));
    })(accounting = bluemoon.accounting || (bluemoon.accounting = {}));
})(bluemoon || (bluemoon = {}));
//# sourceMappingURL=quarter-report-statements-ar.js.map
var bluemoon;
(function (bluemoon) {
    var accounting;
    (function (accounting) {
        var Components;
        (function (Components) {
            'use strict';
            var QuarterReportStatementUrlManager = (function () {
                function QuarterReportStatementUrlManager($http) {
                    this.httpService = $http;
                }
                QuarterReportStatementUrlManager.prototype.getReportUrl = function (company, client, year, quarter) {
                    var api = '/api/accounting/v1/quarter-report-statement/company/{company}' +
                        '/client/{client}/year/{year}/quarter/{quarter}/reports/document-stream-preview-url';
                    api = api.replace('{company}', company);
                    api = api.replace('{client}', client);
                    api = api.replace('{year}', year.toString());
                    api = api.replace('{quarter}', quarter.toString());
                    var httpConfig = {
                        method: 'GET',
                        url: api,
                        cache: false
                    };
                    return this.httpService(httpConfig).then(function (response) { return response.data; });
                };
                QuarterReportStatementUrlManager.$inject = ['$http'];
                return QuarterReportStatementUrlManager;
            }());
            Components.QuarterReportStatementUrlManager = QuarterReportStatementUrlManager;
            angular.module('bluemoon.accounting.components.QuarterReportStatementUrlManager', [])
                .service('quarterReportStatementUrlManager', QuarterReportStatementUrlManager);
        })(Components = accounting.Components || (accounting.Components = {}));
    })(accounting = bluemoon.accounting || (bluemoon.accounting = {}));
})(bluemoon || (bluemoon = {}));
//# sourceMappingURL=quarter-report-statement-url-manager.js.map
angular.module('bluemoon.accounting.components.templates', ['src/dashboards/quarter-report-statements-ar/quarter-report-statements-ar.html']);

angular.module("src/dashboards/quarter-report-statements-ar/quarter-report-statements-ar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("src/dashboards/quarter-report-statements-ar/quarter-report-statements-ar.html",
    "<div class=\"bmac-quarter-report-statements-ar-component\">\n" +
    "	<div class=\"bmac-quarter-report-statements-ar-inner\" bento-busy-loader=\"$ctrl.isLoading\">\n" +
    "		<div class=\"bmac-quarter-report-statements-ar-row bmac-quarter-report-statements-ar-header\">\n" +
    "			<a class=\"bento-icon-chevron-left\" ng-click=\"$ctrl.reduceYear()\"></a><span>{{$ctrl.IsLoading}}{{$ctrl.selectedYear}}</span><a class=\"bento-icon-chevron-right\" ng-click=\"$ctrl.increaseYear()\"></a>\n" +
    "		</div>\n" +
    "		<div class=\"bmac-quarter-report-statements-ar-row bmac-quarter-report-statements-ar-report-link\">\n" +
    "			<a ng-click=\"$ctrl.openReport(1)\"><i class=\"bento-icon-file-pdf\"></i><span class=\"bmac-quarter-report-statements-ar-report-title\" translate>Bluemoon.Accounting.Components.QuarterReportStatementOne</span><i class=\"bento-icon-newtab\" href=\"\"></i></a>\n" +
    "		</div>\n" +
    "		<div class=\"bmac-quarter-report-statements-ar-row bmac-quarter-report-statements-ar-report-link\">\n" +
    "			<a ng-click=\"$ctrl.openReport(2)\" ng-show=\"$ctrl.showQuarter(2)\"><i class=\"bento-icon-file-pdf\"></i><span class=\"bmac-quarter-report-statements-ar-report-title\" translate>Bluemoon.Accounting.Components.QuarterReportStatementTwo</span><i class=\"bento-icon-newtab\" href=\"\"></i></a>\n" +
    "		</div>\n" +
    "		<div class=\"bmac-quarter-report-statements-ar-row bmac-quarter-report-statements-ar-report-link\">\n" +
    "			<a ng-click=\"$ctrl.openReport(3)\" ng-show=\"$ctrl.showQuarter(3)\"><i class=\"bento-icon-file-pdf\"></i><span class=\"bmac-quarter-report-statements-ar-report-title\" translate>Bluemoon.Accounting.Components.QuarterReportStatementThree</span><i class=\"bento-icon-newtab\" href=\"\"></i></a>\n" +
    "		</div>\n" +
    "		<div class=\"bmac-quarter-report-statements-ar-row bmac-quarter-report-statements-ar-report-footer\">\n" +
    "\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

(function (angular) {
    'use strict';

    angular.module('bluemoon.accounting.components.ClientDashboard', [
		'bluemoon.accounting.components.templates',
		'bluemoon.accounting.components.QuarterReportStatementsAr',
		'bluemoon.accounting.components.QuarterReportStatementUrlManager'
    ]);

}(window.angular));
